export enum NotificationType {
  OrderCreated = 100,
  OrderMessageCreated = 150,
  OrderStatusUpdate = 175,
  JournalCashUpVariance = 200,
  JournalEventCreated = 250,
  LocationCreated = 300,
  ProductPriceUpdated = 400,
  EntityCustomerCreated = 500,
  GlobalProductApproved = 600,
  StockEventCreated = 700,
  MinimumStockLevel = 701,
}
